import { Injectable, effect, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);

  private avatarUrlSignal = signal<string | undefined>(undefined);
  readonly avatarUrl = this.avatarUrlSignal.asReadonly();
  private currentObjectUrl: string | null = null;

  constructor() {
    effect(() => {
      const authed = this.authService.isAuthenticated();
      if (!authed) {
        this.clearAvatar();
        return;
      }
      this.fetchGraphAvatar();
    });
  }

  private setAvatarUrl(url: string, isObjectUrl: boolean): void {
    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
      this.currentObjectUrl = null;
    }
    if (isObjectUrl) {
      this.currentObjectUrl = url;
    }
    this.avatarUrlSignal.set(url);
  }

  private clearAvatar(): void {
    if (this.currentObjectUrl) {
      URL.revokeObjectURL(this.currentObjectUrl);
      this.currentObjectUrl = null;
    }
    this.avatarUrlSignal.set(undefined);
  }

  private fetchGraphAvatar(): void {
    this.http
      .get('https://graph.microsoft.com/v1.0/me/photo/$value', {
        responseType: 'blob',
      })
      .subscribe({
        next: (blob) => {
          if (blob && blob.size > 0) {
            const objUrl = URL.createObjectURL(blob);
            this.setAvatarUrl(objUrl, true);
          }
        },
        error: () => {
          // avatar fallback
        },
      });
  }
}
